export function transTon(ton: number) {
  if (ton <= 0) return "noExists";
  if (ton === 2) return "2TONS";
  if (0 < ton && ton < 3) return "TON2";
  return "TONS";
}

export function transYear(year: number) {
  if (year <= 0) return "noWarranty";
  if (year === 1) return "year";
  if (year === 2) return "2years";
  return "years";
}

export function toChar(code: number) {
  return String.fromCharCode(code);
}
